export const generateMarksTable = (data) => {
	return `
		<table>
			<thead>
				<tr>
					<th>Question</th>
					<th>Answer</th>
					<th>Content focus</th>
					<th>Complexity</th>
				</tr>
			</thead>
			<tbody>
				${data.map(c => `
					<tr>
						<td><div class="chip">${c.question}</div></td>
						<td>${c.answer}</td>
						<td>${c.contentFocus}</td>
						<td>${c.complexity}</td>
					</tr>
				`).join('')}
			</tbody>
		</table>
		<style>
			* { font-family: Tahoma, Geneva, Verdana, sans-serif !important; }
			table { border-collapse: collapse; width: 100%; }
			thead { background-color: #ff3334; color: white; }
			th, tr, td { border: 1px solid #333333; }
			th, td { padding: 4px; text-align: center; vertical-align: middle; }
			td:nth-of-type(1) { width: 15%; min-width: 15%; }
			td:nth-of-type(2) { width: 15%; min-width: 15%; }
			td:nth-of-type(3) { width: 60%; min-width: 60%; }
			td:nth-of-type(4) { width: 20%; min-width: 20%; }
			.chip {
				display: inline-flex;
				justify-content: center;
				align-items: center;
				width: 30px;
				height: 30px;
				border-radius: 50%;
				background-color: #ff3334;
				color: white;
			}
		</style>
	`
}

export const generateExamReport = (
	dataToConvert,
	{ headerText = '', results = [], writingResult = {}, multiple = false } = {}
) => {
	const nativeScales = ['NI', 'F', 'G', 'VG', 'E'];
	
	const generateScalesRow = (scales = [], addSpacerCell = false) => {
		if (!scales.length) return '';

		const htmlScales = scales.map(c => `<th class="mark-cell">${c}</th>`);
		
		// adding mark cells to fill the row 
		if (htmlScales.length < nativeScales.length) {
			for (let i = 0; i < nativeScales.length - htmlScales.length; i++) {
				htmlScales.push('<th class="mark-cell"></th>');
			}
		}
		return `
			<tr>
				${addSpacerCell ? '<th colspan="1" class="mark-cell" style="background-color: #ddd;"></th>' : ''}
				${htmlScales.join(' ')}
			</tr>
		`;
	}
	
	const generateContent = (data, options = {}) => {
		const refactoredData = (() => {
			const dataClone = data;
			const sortByScales = (arr) => {
				// normalize scales by sorting and converting to string
				const normalize = scales => scales.sort((a, b) => a - b).join(',');

				// group items by normalized scales
				const grouped = arr.reduce((map, item) => {
					const key = normalize(item.scales);
					if (!map.has(key)) map.set(key, []);
					map.get(key).push(item);
					return map;
				}, new Map());

				// flatten grouped items into a sorted array
				return Array.from(grouped.values()).flat();
			}

			let prevScales = [];
			for (let i = 0; i < dataClone.length; i++) {
				dataClone[i].children = sortByScales(dataClone[i].children);
				
				let scalesCount = 0;
				for (let j = 0; j < dataClone[i].children.length; j++) {
					const child = dataClone[i].children[j];
					
					if (
						(
							prevScales.join() !== child.scales.join() &&
							child.scales.join().length
						) || (
							prevScales.join() !== nativeScales.join() &&
							!child.scales.join().length
						)
					) {
						prevScales = child.scales.length ? child.scales : nativeScales;
						scalesCount++;
						dataClone[i].children[j] = {
							subject: child.subject,
							mark: child.mark,
							scales: prevScales
						}
					} else {
						dataClone[i].children[j] = {
							subject: child.subject,
							mark: child.mark,
							scales: []
						}
					}
				}
				
				dataClone[i].rowSpan = dataClone[i].children.length + scalesCount - (i === 0 ? 1 : 0);
			}
			return dataClone;
		})();

		const resultsData = Array.isArray(options.results) ? options.results : [];
		return `
			<div class="d-flex justify-space-between align-center" style="margin-bottom: 10px;">
				<img src="${require('@/assets/school-logo.png')}" height="30">
				<div dir="auto" class="header-text">${options.headerText}</div>
			</div>
			<div class="d-flex flex-column">
				<div style="margin-bottom: 10px;">
					<table style="margin-bottom: 10px;">
						<thead>
							<tr>
								<th rowspan="2" colspan="2">Subject</th>
								<th colspan="5">Marks</th>
							</tr>
							${refactoredData.map((c, index) => index === 0 && c.children[0] ? generateScalesRow(c.children[0].scales || []) : '').join('')}
						</thead>
						<tbody>
							${refactoredData.map((c, index) => c.children.map((e, i) => `
								${i !== 0 ? generateScalesRow(e.scales || [], true) : ''}
								<tr>
									${i === 0 ? `<td rowspan="${c.rowSpan}" class="rotate-header">${c.subject}</td>` : ''}
									<td class="subject-header">${e.subject}</td>
									<td>${e.mark === 0 || e.mark === -1 ? (e.mark === 0 ? '✔' : '-') : ''}</td>
									<td>${e.mark === 1 ? '✔' : ''}</td>
									<td>${e.mark === 2 ? '✔' : ''}</td>
									<td>${e.mark === 3 ? '✔' : ''}</td>
									<td>${e.mark === 4 ? '✔' : ''}</td>
								</tr>
							`).join('')).join('')}
							
						</tbody>
					</table>

					<table>
						<thead>
							<tr>
								<th colspan="3">Test Result</th>
								<th colspan="2" style="width: 16%;">Marks</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="${(resultsData.length || 1) + 1}" class="rotate-header">Language Art</td>
								<td rowspan="${resultsData.length || 1}" class="rotate-header">Reading Test</td>
								<td>${resultsData[0]?.subject || ''}</td>
								<td>${resultsData[0]?.percentage || ''}</td>
								<td>${resultsData[0]?.lateralMark || ''}</td>
							</tr>
							${resultsData.slice(1).map(c => `<tr><td>${c.subject}</td><td>${c.percentage}</td><td>${c.lateralMark}</td></tr>`).join('')}
							<tr>
								<td colspan="2">Writing Test</td>
								<td>${options.writingResult.percentage}</td>
								<td>${options.writingResult.lateralMark}</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div style="white-space: pre-line;"><b>Reading in Phrases:</b> the ability to read strings of words, not word by word
					<b>Pace:</b> the speed at which the student reads
					<b>Syntax:</b> the ability to read correctly without mistakes in the organization of words into sentences
					<b>Self-Correction:</b> the ability to monitor the mistakes by correcting them immediately
					<b>Innotation:</b> the ability to read with expression and effect i.e. rising the pitch when asking a question
					<b>Letter Naming Fluency:</b> the ability to recognize letters quickly by giving the names of the letters
					<b>Sight Word Fluency:</b> the ability to read decodable words quickly
					<b>Comprehension:</b> the ability to understand the text
					<b>Phoneme Categorization:</b> the ability to identify phonemes as a word
					<b>Phoneme Blending:</b> the ability to combine separate sounds into words
					<b>Phoneme Segmentation:</b> the ability to segment words into their phonemes
					<b>Spelling:</b> the ability to know the correct spelling of words
					<b>Vocabulary:</b> the ability to learn words and know how to use them
					<b>Ideas & Content:</b> student's application of foundational skills i.e. readers to writers in Reading/Writing Workshop
					<b>Grammar:</b> the ability to learn and apply grammar rules
					<b>Structural Analysis:</b> the ability to analyze words into roots, suffixes, prefixes, etc.
					<b>Writing:</b> the ability to write about something pertaining to the concept
					<b>Interactive Read-Aloud:</b> the ability to understand and/or tell texts illustrated in pictures, read aloud interactively and fluently, and use grammar correctly in speaking
					<b>Retelling Cards:</b> student's ability to retell a short story illustrated in pictures using their own words and using grammar correctly in speaking
					<b>Participation:</b> student's interaction with the teacher and the other students
					<b>Completion of Work:</b> student's performance when performing the tasks given to them by the teacher
					<b>Concentration:</b> student's attention in class
					<b>Self-Direction:</b> student's performance upon given instructions i.e. access complex text and test evidence in reading comprehension
					<b>Collaboration with Others:</b> working with students in pairs or groups
					<b>Behavior:</b> the way in which students behave in class in terms of discipline
					<b>Presentation of Assignment:</b> student's results after completing the assignments
					<b>Movement Video:</b> kinetic song that aims at native-like fluency and the total physical response of the students

					<b>EVALUATION KEY:</b>
					<b>Level 4:</b> The student reads in large, meaningful phrases, may occasionally repeat words or short phrases, but the overall content system of the passage is not affected; reads at an appropriate rate of speed with expressive interpretation.
					<b>Level 3:</b> The student reads in three- or four-word phrases; reads primarily in phrases that preserve the passage's syntax and structure; attempts to read expressively; generally reads at an appropriate rate of speed.
					<b>Level 2:</b> The student reads mainly in two-word phrases, with some longer phrases and at times word-by-word; may group words awkwardly and not connect phrases to the deeper context of the passage; reads sections of the passage expressively slowly or quickly.
					<b>Level 1:</b> The student reads word-by-word, with some longer phrases; does not derive meaningfully well with an appropriate rate of speed; reads the passage expressively, but softly.
				</div>
			</div>
		`
	};

	let content = '';
	if (!multiple) {
		content = generateContent(dataToConvert, { headerText, results, writingResult });
	} else {
		content = dataToConvert.map(c => {
			return generateContent(c.data, c.options || { headerText, results, writingResult });
		}).join('<div class="page-break"></div>');
	}
	return `
		${content}	

		<style>
			* { font-family: 'Times New Roman', Times, serif !important; font-size: 10pt; }
			.rotate-header {
				/* transform: rotate(180deg);
				writing-mode: vertical-rl; */
				width: 16%;
				min-width: 16%;
				font-weight: 500;
			}
			.subject-header {
				width: 20%;
				min-width: 20%;
			}
			table { border-collapse: collapse; width: 100%; }
			thead { background-color: #ff3334; color: white; }
			th, tr, td { border: 1px solid #333333; }
			th, td { padding: 0; text-align: center; vertical-align: middle; }
			.header-text { font-size: 10pt; font-weight: bold; }
			.mark-cell { width: 8%; min-width: 8%; background-color: #ffffff; color: #000000; }
			.d-flex { display: flex; }
			.d-flex > * { padding: 6px; }
			.flex-25 { flex-basis: 25%; }
			.flex-50 { flex-basis: 50%; }
			.flex-75 { flex-basis: 75%; }
			.flex-100 { flex-basis: 100%; }
			.flex-column { flex-direction: column; }
			.align-center { align-items: center; }
			.justify-space-between { justify-content: space-between; }

			.text-black { font-weight: bold; }
			
			.circle {  
				display: inline-block;
				width: 5px;
				height: 5px;
				border-radius: 50%;
				background-color: black;
			}
			.page-break {
				page-break-before: always; /* or page-break-after: always; */
				break-before: page; /* modern alternative */
			}	
		</style>
	`
}